import { render, staticRenderFns } from "./PrintNotice.vue?vue&type=template&id=2c29611c&scoped=true&"
import script from "./PrintNotice.vue?vue&type=script&lang=js&"
export * from "./PrintNotice.vue?vue&type=script&lang=js&"
import style0 from "./PrintNotice.vue?vue&type=style&index=0&id=2c29611c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29611c",
  null
  
)

export default component.exports